<template>
  <div class="main jcc ais">
    <div class="main__block">
      <div class="title">選擇問題</div>
      <div v-if="showReferralCodeCard && referralCodeData && referralCodeData.checked" class="referral-card" style="margin-bottom: 20px;">
        <div class="referral-code-block">
          <div class="referral-label">推薦碼</div>
          <div class="referral-code">{{ referralCodeData.referral_code }}</div>
        </div>
        <div class="referral-divider"></div>
        <div class="referral-period-block">
          <div class="referral-label">活動期間</div>
          <div class="referral-period">{{ referralCodeData.res_data.campaign_info.start }} 至 {{ referralCodeData.res_data.campaign_info.end }}</div>
        </div>
      </div>
      <div class="flex f-col jcs ais w-100">
        <div class="part__body">
          <div v-for="prob in problemList" :key="prob" class="choose__item square">
            <input v-model="tempMedProblem" :value="prob" type="checkbox" />
            <div class="checkTag">
              <span>{{ prob }}</span>
            </div>
          </div>
        </div>
        
        <div class="flex f-row jce w-100">
          <div @click="chooseTime" class="btn next">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import airleeClinicList from '../config/airleeClinicList';
export default {
  name: 'ChooseMedProblem',
  components: {},
  data() {
    return {
      tempMedProblem: []
    };
  },
  methods: {
    checkClinic() {
      const clinicCode = this.$route.query.clinicCode;
      if (clinicCode) {
        localStorage.setItem('clinicCode', clinicCode);
      } else {
        alert('診所代碼錯誤,請重新登入！');
        this.backToLogin();
      }
    },
    backToLogin() {
      const clinicCode = this.$route.query.clinicCode;
      this.$router.push(`/login?clinicCode=${clinicCode}`);
    },
    async chooseTime() {
      const clinicCode = localStorage.getItem('clinicCode');
      try {
        await this.$store.dispatch('resvModule/setTime', { data: this.needTime, clinicCode, });
        if (this.tempMedProblem.length > 0) {
          await this.$store.dispatch('resvModule/setMedProblem', { data: this.tempMedProblem.join(','), clinicCode, });
        }
        this.$router.push(`/choose-time?clinicCode=${this.$route.query.clinicCode}`);
      } catch (e) {
        const tokenError = ['無效的token', 'token錯誤', '該token已失效'];
        if (tokenError.indexOf(e) > -1) {
          alert('請重新登入');
          this.$router.push(`/login?clinicCode=${clinicCode}`);
        } else if (e == 'his api not found') {
          alert('請重新登入');
          this.$router.push(`/login?clinicCode=${clinicCode}`);
        } else {
          alert(e);
        }
      }
    },
  },
  computed: {
    ...mapGetters('authModule', ['customerByC', 'clinicByC', 'mgmIsEnableByC']),
    ...mapGetters('resvModule', ['roomByC']),
    ...mapGetters('mgmModule', ['referralCodeDataByC']),
    customer() {
      const clinicCode = this.$route.query.clinicCode;
      return this.customerByC(clinicCode);
    },
    room() {
      const clinicCode = this.$route.query.clinicCode;
      return this.roomByC(clinicCode);
    },
    needTime() {
      const schlen = 10;
      const checkin = 0;
      return { schlen, checkin, };
    },
    clinic() {
      const clinicCode = this.$route.query.clinicCode;
      return this.clinicByC(clinicCode);
    },
    referralCodeData() {
      const clinicCode = this.$route.query.clinicCode;
      return this.referralCodeDataByC(clinicCode);
    },
    isAirleeClinic() {
      // 檢查當前診所是否為愛爾麗
      if (airleeClinicList.some(clinic => clinic.clinic_sn === this.$route.query.clinicCode)) {
        return true;
      }
      return false;
    },
    mgm_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.mgmIsEnableByC(clinicCode);
    },
    showReferralCodeCard() {
      // 1) 先判斷是否愛爾麗，愛爾麗不受 mgm_is_enable 控制
      if (this.isAirleeClinic) {
        return true;
      }
      // 2) 一般診所：需 MGM 開關開啟
      return parseInt(this.mgm_is_enable, 10) === 1;
    },
    problemList() {
      let problemList = [];
      if (this.clinic.name == '膚適美') {
        problemList = ['斑點色素問題','刺青', '胎記', '上下眼線', '紋繡眉', '凹洞痘疤', '毛孔問題', '紅色痘疤', '血管問題', '痣', '贅生物'];
      } else if (this.clinic.name.indexOf('木木日安') > -1) {
        problemList = ['斑點色素問題','刺青', '胎記', '上下眼線', '紋繡眉', '凹洞痘疤', '毛孔問題', '紅色痘疤', '血管問題', '痣', '贅生物', '黑色痘疤', '色素疤痕', '凹凸疤痕', '動態表情紋', '瘦小臉'];
      } else {
        problemList = ['斑點色素問題','刺青', '胎記', '上下眼線', '紋繡眉', '凹洞痘疤', '毛孔問題', '紅色痘疤', '血管問題', '痣', '贅生物', '黑色痘疤', '色素疤痕', '凹凸疤痕', '動態表情紋', '瘦小臉'];
      }
      return problemList;
    }
  },
  async created() {
    await this.checkClinic();
    window.scrollTo(0, 0);
  },
};
</script>
